import router from './router'
// import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
NProgress.configure({
  showSpinner: false
}) // NProgress Configuration
router.beforeEach(() => {
  NProgress.start() // start progress bar
})
router.afterEach(() => {
  NProgress.done() // finish progress bar
})
